/* globals VXConfig */
import PropTypes                  from 'prop-types';
import Translations               from '../../utils/Translations';
import React                      from 'react';
import SocialShareBarShareContent from './SocialShareBarShareContent';
import SocialShareBarEmailContent from './SocialShareBarEmailContent';
import SocialShareBarEmbedContent from './SocialShareBarEmbedContent';
import './../../../../src/VX/Asset/Less/VX/View/social-share-bar.less';

// Internally used Ids
const SOCIAL_SHARE_TAB_ID = 1;
const EMAIL_SHARE_TAB_ID  = 2;
const EMBED_SHARE_TAB_ID  = 3;

// THESE HAVE TO BE EQUAL TO THE CONSTANTS IN EnumSocialShareBarOptions.php
const SOCIAL_SHARE_TAB = 'socialShareTab';
const EMAIL_TAB        = 'emailTab';
const EMBED_TAB        = 'embedTab';


class SocialShareBar extends React.PureComponent {

	constructor(props) {
		super(props);

		let activeTab = SOCIAL_SHARE_TAB_ID;

		// Set starting Tab, is needed if some Tabs are disabled
		if (props.shownTabs && props.shownTabs[SOCIAL_SHARE_TAB] !== true) {
				if (props.shownTabs[EMAIL_TAB] === true) {
					activeTab = EMAIL_SHARE_TAB_ID;
				} else {
					activeTab = EMBED_SHARE_TAB_ID;
				}
			}

		this.state = {
			activeTab:          activeTab,
			socialShareVisible: false,
		};

		this.onClickShareTab   = this.onClickShareTab.bind(this);
		this.onClickEmailTab   = this.onClickEmailTab.bind(this);
		this.onClickEmbededTab = this.onClickEmbededTab.bind(this);
		this.onShareClick      = this.onShareClick.bind(this);
	}

	onClickShareTab() {
		this.setState({activeTab: SOCIAL_SHARE_TAB_ID});
	}

	onClickEmailTab() {
		this.setState({activeTab: EMAIL_SHARE_TAB_ID});
	}

	onClickEmbededTab() {
		this.setState({activeTab: EMBED_SHARE_TAB_ID});
	}

	onShareClick() {
		this.setState({socialShareVisible: !this.state.socialShareVisible});
	}


	render() {
		let socialShareTabCLassName = 'social-share-bar__button tab ' + this.props.cssModifier;
		let emailShareTabClassName  = 'social-share-bar__button tab';
		let embedShareTabClassName  = 'social-share-bar__button tab';

		let shownContent;

		// Set active Tab
		switch (this.state.activeTab) {
			case SOCIAL_SHARE_TAB_ID :
				socialShareTabCLassName = 'social-share-bar__button tab is-active ' + this.props.cssModifier;
				shownContent            = (
					<SocialShareBarShareContent shownShareButtons={this.props.shownShareButtons}
					                            url={this.props.url}
					                            title={this.props.title}
					                            mediaId={this.props.mediaId}
					                            gaPrefix={this.props.gaPrefix}
					                            isSeekableMedia={this.props.isSeekableMedia}
					                            cssModifier={this.props.cssModifier}
					/>
				);
				break;
			case EMAIL_SHARE_TAB_ID :
				emailShareTabClassName = 'social-share-bar__button tab is-active ' + this.props.cssModifier;
				shownContent           = (
					<SocialShareBarEmailContent videoUrl={this.props.url}
					                            videoTitle={this.props.title}
					                            loggedIn={this.props.loggedIn}
					                            videoId={this.props.mediaId}
					                            guestId={this.props.guestId}
					/>
				);
				break;
			case EMBED_SHARE_TAB_ID :
				embedShareTabClassName = 'social-share-bar__button tab is-active ' + this.props.cssModifier;
				shownContent           = (
					<SocialShareBarEmbedContent videoId={this.props.mediaId} embedBaseUrl={this.props.embedBaseUrl} />
				);
				break;

			default:
				break;
		}

		// Define Tabs if enabled
		const enabledTabs = this.props.shownTabs;
		const shownTabs   = [];

		if (enabledTabs[SOCIAL_SHARE_TAB] === true) {
			const socialShareTab = (
				<button className={socialShareTabCLassName} onClick={this.onClickShareTab}>
					{this.props.gaPrefix !== 'contest' ? <i className={'icon -icon-share-icon social-share-bar__icon share ' + this.props.cssModifier} /> : ''}
					{Translations.get('SocialShareShareWithFriends')}
					{this.props.gaPrefix === 'contest' ? <i className={"icon  " + ((this.state.socialShareVisible) ? '-icon-single-arrow-up-line' : '-icon-single-arrow-down-line') + ' social-share-bar__icon arrow'} onClick={this.onShareClick}/> : ''}
				</button>
			);
			shownTabs.push(socialShareTab);
		}

		if (enabledTabs[EMAIL_TAB] === true) {
			const emailTab = (
				<button className={emailShareTabClassName} onClick={this.onClickEmailTab}>
					<i className='icon -icon-envelope-full social-share-bar__icon email' />
					{Translations.get('SocialShareSendEmail')}
				</button>
			);
			shownTabs.push(emailTab);
		}

		if (enabledTabs[EMBED_TAB] === true) {
			const embedTab = (
				<button className={embedShareTabClassName} onClick={this.onClickEmbededTab}>
					<i className='icon -icon-single-arrow-left-line social-share-bar__icon arrow' />
					<i className='icon -icon-single-arrow-right-line social-share-bar__icon arrow' />
					{Translations.get('SocialShareEmbed')}
				</button>
			);
			shownTabs.push(embedTab);
		}

		const navigationTabs = (
			<div className="social-share-bar__div">
				{shownTabs}
			</div>
		);

		return (
			<div className={'social-share-bar__top-level ' + this.props.cssModifier}>
				{navigationTabs}
				{VXConfig.isVXMobilePlatform ? (this.props.gaPrefix === 'contest' && this.state.socialShareVisible ? shownContent : null) : shownContent}
			</div>
		);

	}
}

SocialShareBar.propTypes = {
	mediaId:           PropTypes.string,
	url:               PropTypes.string,
	title:             PropTypes.string,
	shownShareButtons: PropTypes.array,
	shownTabs:         PropTypes.shape({
		socialShareTab: PropTypes.bool,
		emailTab:       PropTypes.bool,
		embedTab:       PropTypes.bool,
	}),
	loggedIn:          PropTypes.bool,
	guestId:           PropTypes.number,
	embedBaseUrl:      PropTypes.string,
	gaPrefix:          PropTypes.string,
	isActorVideo:      PropTypes.bool,
	isSeekableMedia:   PropTypes.bool,
	cssModifier:       PropTypes.string,
};

SocialShareBar.defaultProps = {
	isSeekableMedia: true,
	cssModifier:     '',
};

export default SocialShareBar;
